// @ts-nocheck

const EVENTNAME = 'BUTTON_LOADER'

const subscribe = (listner) => {
  document.addEventListener(EVENTNAME, listner)
}

const unSubscribe = (listner) => {
  document.removeEventListener(EVENTNAME, listner)
}

const publish = (showLoader, loaderFor) => {
  const event = new CustomEvent(EVENTNAME, { detail: { showLoader, loaderFor } })
  document.dispatchEvent(event)
}

export default { publish, subscribe, unSubscribe }
